<template>
  <header class="nav-root">
    <nav class="nav-wrap">
      <!-- Brand -->
      <a href="https://fundatusitioweb.com" class="brand" aria-label="Ir al inicio">
        <img
          class="brand-logo"
          alt="FUNDA TU SITIO WEB"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAvCAYAAAB6zDPWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOGSURBVHgBzVn/ddowEL709f9mBG1QsgGZoGSCuBt4A7sThE5gOkHSCaAT0ExgMkHY4HKHZZDPOkk2BPje00Oy7uRPn06/DMAJgYhTSktsUFEycG0gUreUntCPAq4FVs0aw6gvqnJAzXdKq6tROaDmqlWQfieKzXlUjqiZK/ZzPLfKKWqO8OVnUzgVMDzTS5eQ4muc/OepHFBkTWkiO+PxN5JMRGUDQ4HpanYmUYBsh8zJVI70fBLqTIRsjwzlMxyjMobVZBVuI51JJdshY20Wil0BA9WcJnSG7SaKCAb1HS4fpDJlZkpDrpocm+uYXQhkUyr+S0yL5Rl4SNToLEOULxTnvZ19SQH+0ModMqERzCIj/Q7i4TMe1DQYURNFaCgh0OLJ2oditHLef2v57AHCuHReVHkaq/GgZi8WI2RbfxOJ0WctdL6ADiPKvynd3dzcrGzvlx6bGAz7sT+1s6D8PaU/wmaiOYfIuthQ4zmlrS0X0Ce6hTQY6w/UHrebUfZ/imOIrHeG22GUJ6wNpTtpy2To5yf0O5JjdwVJ6uhgsoSZ59m9JdaDHe5fnqocBiI1DN6c/A9Rt2CidsKsxWyu+DnVz6Gvnhqbx5J1YUT51f4+WgJLGyo8ATM4jMRf4fcdBuIrHI+t+GXCtVPfhtM3OBJjlN2Icjucr4r9Qti1eIOBGENWknq0w85xKZegfzzBsNlKjahLWq5cjCH7Iso8zLzr8ELPy9cDNLP/gcq8x7OivgP13MkbSEAq2X288Q5GPytR306sDJowWVDaYnO48e10C22pg1B4oH42qEVdhd0Dc43jUKNzC8D+qW7l1CWfDTainIFVz6ry4LGJYQN2A0F7RqZyKWxqxXcrld3HETaL+lJRp8JG3dAxUmJl7Xdn35CNw8G9mdT84F047M6djkPusdk54+G4yLvXi8eu/e7V2mmHb7YrXRk9HdqRnYeIWMeQgrJzreJGjJJ2f1sLW+0KVbYG80QipWJXo/IZCI9Ts0We2miHCIZXgiJRTRmbmpr7Lz8+FUK3y0q8IKRyjrqauXhfobRTQgow/RY6ZL2Vaka//CQDT6Myw6dm9MvPKKCuHj/LInapauqxOZK0pl4lCGXWduo8S/oqeVJEVJ4pPudRM0A6qjKG/38o4ZyIqFyhf4vuxPDZYVX2EZNqDr56fwqsykuF6GXV1IDdnet61LwEPgB1zx21HlpHfQAAAABJRU5ErkJggg==" />
        <div class="brand-text">
          <strong>FUNDA TU SITIO WEB</strong>
          <span>Imagina · Créalo</span>
        </div>
      </a>

      <!-- Actions -->
      <div class="nav-actions">
        <a class="btn ghost" href="https://fundatusitioweb.com/nuestrotrabajo" target="_blank" rel="noopener">Ir a otros proyectos</a>
        <a class="btn solid" href="https://fundatusitioweb.com/contacto" target="_blank" rel="noopener">Cotiza tu proyecto</a>
      </div>
    </nav>
  </header>
</template>

<style scoped>
nav {
    font-size: 0.6em;
}
.nav-root{
  position: sticky; top: 0; z-index: 40;
  background: linear-gradient(180deg,var(--panel),rgba(0,0,0,0));
  backdrop-filter: saturate(1.2) blur(6px);
  border-bottom: 1px solid var(--border);
}
.nav-wrap{
  max-width: 1200px; margin: 0 auto; padding: 14px 16px;
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
}
.brand{ display:flex; align-items:center; gap:12px; text-decoration:none; color: var(--text); }
.brand-logo{ height: 36px; width: auto; border-radius: 8px }
.brand-text{ display:none }
.brand-text strong{ display:block; line-height:1 }
.brand-text span{ font-size:12px; color: var(--muted) }
@media (min-width: 520px){ .brand-text{ display:block } }

.nav-actions{ display:flex; gap:10px; align-items:center }
.btn{
  display:inline-flex; align-items:center; justify-content:center; gap:8px;
  padding: 10px 14px; border-radius: 12px; text-decoration:none; font-weight:600;
  border: 1px solid transparent; transition: .2s ease;
}
.btn.ghost{ color: var(--text); border-color: var(--border); background: var(--panel-2) }
.btn.ghost:hover{ border-color:#3a3f4b }
.btn.solid{ background: var(--brand-600); color: #fff; box-shadow: 0 8px 20px rgba(124,77,255,.25) }
.btn.solid:hover{ background: var(--brand-700) }
</style>
